var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-breadcrumbs',{staticClass:"px-0 py-0 font-bold dark:text-white",attrs:{"large":"","items":_vm.items}})
}
var staticRenderFns = []

export { render, staticRenderFns }